import { useContext } from 'react'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { apiGet, apiPost, apiPatch } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getIssueNotificationPreference = async (token, userId) => {
  const url = `users/${userId}/issue_notification_preference`
  const data = await apiGet({ url, token })
  return data
}

export const useIssueNotificationPreference = ({ options } = {}) => {
  const token = useContext(AuthContext)
  const { id: userId } = useContext(UserContext)
  const queryFn = () => getIssueNotificationPreference(token, userId)
  const queryKey = ['users', userId, 'issue_notification_preference']

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

const createIssueNotificationPreference = async (token, userId, params) => {
  const url = `users/${userId}/issue_notification_preference`
  const data = await apiPost({ url, token, objectName: 'issue_notification_preference', params })
  return data
}

export const useCreateIssueNotificationPreference = ({ options } = {}) => {
  const token = useContext(AuthContext)
  const { id: userId } = useContext(UserContext)
  const queryClient = useQueryClient()

  return useMutation(
    (params) => createIssueNotificationPreference(token, userId, params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['users', userId, 'issue_notification_preference'])
      },
      ...options
    }
  )
}

const updateIssueNotificationPreference = async (token, userId, params) => {
  const url = `users/${userId}/issue_notification_preference`
  const data = await apiPatch({ url, token, objectName: 'issue_notification_preference', params })
  return data
}

export const useUpdateIssueNotificationPreference = ({ options } = {}) => {
  const token = useContext(AuthContext)
  const { id: userId } = useContext(UserContext)
  const queryClient = useQueryClient()

  return useMutation(
    (params) => updateIssueNotificationPreference(token, userId, params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['users', userId, 'issue_notification_preference'])
      },
      ...options
    }
  )
}
